import validator from 'validator';
import curry from 'lodash/curry';

export const required = val => (validator.isEmpty(val) ? 'Required' : undefined);

export const lat = val => (validator.isLatLong(`${val},0`) ? undefined : 'Must be a valid latitude');

export const lng = val => (validator.isLatLong(`0,${val}`) ? undefined : 'Must be a valid longitude');

export const maxLength = curry((max, val) => (validator.isLength(val, { min: 0, max }) ? undefined : `Must be at most ${max} characters`));

export const zip = val => (validator.isPostalCode(val, 'US') ? undefined : 'Must be a valid postal code');

export const between = curry((min, max, val) => ((val >= min && val <= max) ? undefined : `Must be a valid number between ${min} and ${max}`));

export const noInvalidFilenameChars = val => (/[/\\:*?"<>|]/.test(val) || /\0/.test(val) ? 'Cannot contain: / \\ : * ? " < > |' : undefined);
